var added=0;
var side=0;
var scanBlocked=false; // prevent excessive reads


function openScanModal() {
    openModal();
    var w = window.innerWidth > 680 ? 600 : window.innerWidth-40;
    var h = window.innerHeight > 680 ? 600 : window.innerHeight-40;
    side=h>w?w:h; 
    var scannerCont=document.getElementById("scanner-container");
    if (scannerCont)  {
      scannerCont.style.width=side+"px";
      scannerCont.style.height=side+"px";
    }
    startScanner();
}

if (document.getElementById('barcode-scanner')) {
  document.getElementById('barcode-scanner').addEventListener('click', openScanModal);
}

function convertToVariantId(barcode) {
  if (!barcodeToVariantMap || barcodeToVariantMap.size<1000 ) {
      console.error("barcodeToVariantMap empty or small");
  } else {
       var variantId=barcodeToVariantMap[barcode];
      if (variantId ) return variantId; 
  }
  return 0;
} 

function convertSkuToVariantId(sku) {
  if (!skuToVariantMap || skuToVariantMap.size<1000 ) {
      console.error("skuToVariantMap empty or small");
  } else {
       var variantId=skuToVariantMap[sku];
      if (variantId ) return variantId; 
  }
  return 0;
} 

function startScanner() {
    console.log("scanner: side sid e "+side);
     var videoArea=document.querySelector('#scanner-container');
      
     Quagga.init({
        inputStream: {
            name: "Live",
            type: "LiveStream",       
            constraints: {
              width: side,
              height: side,
              facingMode: "environment" // or user
              },  
            target: videoArea    // where to render scanner
        },
        debug: false,
        locate:true,
  
        locator: {
              halfSample: true,
              patchSize: "medium", // x-small, small, medium, large, x-large
              // debug: {
              //   showCanvas: false,
              //   showPatches: false,
              //   showFoundPatches: true,
              //   showSkeleton: false,
              //   showLabels: false,
              //   showPatchLabels: false,
              //   showRemainingPatchLabels: false,
              //   boxFromPatches: {
              //     showTransformed: false,
              //     showTransformedBox: false,
              //     showBB: false
              //   }
              // }
        },
        decoder: {
            readers: ["ean_reader"
                     // ,"code_128_reader",
                     //  "ean_reader",
                     //  "ean_8_reader",
                     //  "code_39_reader",
                     //  "code_39_vin_reader",
                     //  "codabar_reader",
                     //  "upc_reader",
                     //  "upc_e_reader",
                     //  "i2of5_reader"
                     ],  // EAN reader
            debug: {
                drawBoundingBox: true,
                showFrequency: true,
                drawScanline: false,
                showPattern: false
                }
            },
        }, function(err) {
            if (err) {
                setStatus("Fehler beim Start des Scans","error")
                console.log(err);
                return;
            } 
    
            console.log("Initialization finished. Ready to start");
            Quagga.start();
            setStatus("Bereit zum Scannen! ")
        });

      Quagga.onProcessed(function(result) {
        var drawingCtx = Quagga.canvas.ctx.overlay,
            drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
            if (result.boxes) {
                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                result.boxes.filter(function (box) {
                    return box !== result.box;
                }).forEach(function (box) {
                    Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                });
            }

            if (result.box) {
                Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
            }

            if (result.codeResult && result.codeResult.code) {
                Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
            }
        }
    });


    Quagga.onDetected(function(data) {
        console.log("on detected "+data.codeResult.code);
        if (scanBlocked) {
          console.log("blocked...")
          return; 
        }
        scanBlocked=true;
        setTimeout(function() { 
            window.scanBlocked=false; 
             setStatus("... wieder bereit zum scannen, gescannte Produkte: "+added);
          }, 4000); // no new processing for 2.5 seconds

      
        var barcode = data.codeResult.code;
        var variantId =convertToVariantId(barcode);
        added++;
        // Add product to cart
        addVariantToCart(variantId);
    });
}

function setStatus(msg, status) {
  document.getElementById("scan-status").innerHTML=msg;
  if (status) {
      if  (status=="ok")  {
        highlightModal("#90EE90");
      } else if (status=="error") {
        highlightModal("red");
      }
  }
}
function removeEanCodeFlag() {
  if (window.location.href.includes("/?weanscan")) {
    // Create a new URL object based on the current URL
    let url = new URL(window.location.href);

    // Remove the specific query parameter
    url.searchParams.delete('weanscan');

    // Update the URL without reloading the page
    window.history.pushState({}, '', url.href);
  }
}
  
// Get the modal
var modal = document.getElementById("barcodeScannerModal");

// Get the <span> element that closes the modal
var closeButton = document.getElementsByClassName("close-button")[0];

// When the user clicks on the button, open the modal
function openModal() {
  modal.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
closeButton.onclick = function() {
  Quagga.stop();
  modal.style.display = "none";
  removeEanCodeFlag();
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    Quagga.stop();
    modal.style.display = "none";
    removeEanCodeFlag();
  }
}

function highlightModal(color) {
  var modalContent = document.querySelector('.modal-content');
  modalContent.style.backgroundColor = color; // Change background to green

  // Set a timeout to change the background back to white after 2 seconds
  setTimeout(function() {
    modalContent.style.backgroundColor = 'white';
  }, 1000); // 2000 milliseconds = 2 seconds
}

function addEanToCart() {
    // Assuming the EAN codes are passed as a URL parameter 'waddean'
    // Optionally lname=
    //https://medikamente.wartau.pizolcare.ch/?waddean=4491130,2810364,1927420,211843,4763137&lname=Muster
  
    var urlParams = new URLSearchParams(window.location.search);
    var eanList = urlParams.get('waddean'); // Gets the EAN codes from the URL parameter
    var lname= urlParams.get('lname');
  
    if (!eanList) {
        console.error("No EAN code found: " + urlParams);
        return;
    }
    // https://medikamente.wartau.pizolcare.ch/?waddean=4491130,2810364,1927420,211843,4763137&lname=Muster
    // Convert all EANs to variant IDs
    var variantIds = eanList.split(',')
        .map(ean => ean.trim())
        .map(convertToVariantId)
        .filter(variantId => variantId > 0); // Remove invalid IDs

    if (variantIds.length == 0) {
        variantIds = eanList.split(',')
          .map(ean => ean.trim())
          .map(convertSkuToVariantId)
          .filter(variantId => variantId > 0); // Remove invalid IDs

    }
  

    console.debug("variants "+variantIds)

    if (variantIds.length > 0) {
        console.log("Adding variants to cart: " + variantIds.join(", "));
        addVariantToCart(variantIds, true,lname);
    } else {
        console.error("No valid variant IDs found.");
    }
}

//https://medikamente.wartau.pizolcare.ch/?waddean=4491130,2810364,1927420,211843,4763137&lname=Muster
function addVariantToCart(variantIds, showCart, lname) {
    // Create an array of items for Shopify cart
    var items = variantIds.map(variantId => {
        let item = {
            id: variantId,
            quantity: 1
        };

        if (lname) {
            item.properties = { "Note": lname };
        }

        return item;
    });

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }) // Send all items at once
    }).then(response => {
        console.log(JSON.stringify(response));
        setStatus("Produkte wurden hinzugefügt", "ok");
        console.log('Products added to cart');

        if (showCart) {
            window.location.href = "/cart";
        }
    }).catch(error => {
        console.error('Error:', error);
    });
}

